export default class {
	scrolled = false;

	constructor() {
		this.hamburger();
		this.replaceableLogo();
		this.closeSubMenu();
	}

	hamburger() {
		const hamburger = document.querySelector(".SiteHamburger");
		if (!hamburger) return;

		hamburger.addEventListener("click", (e) => {
			e.preventDefault();
			document.body.classList.toggle("is-hamburger-open");
		});

		const mobileNav = document.querySelectorAll(".SiteMobileNav a");
		mobileNav.forEach((link) => {
			link.addEventListener("click", () => {
				document.body.classList.remove("is-hamburger-open");
			});
		});
	}

	/**
	 * Replace the logo with the secondary logo on scroll
	 * when you scroll past 10 px from top add a class 'scrolled' to the header
	 */
	replaceableLogo() {
		const header = document.querySelector(".SiteHeader");
		const mainElement = document.querySelector(".BlockHeader.is-sticky .BlockHeader__inner");
		if (!header) return;
		if (!mainElement) return;

		window.mainElementHeight = mainElement.offsetHeight;
		
		// add extra padding to following element
		const followingElement = document.querySelector('.BlockHeader.is-sticky + *');
		followingElement.style.paddingTop = followingElement.style.paddingTop + window.mainElementHeight + 'px';

		// add scroll event listener
		window.addEventListener("scroll", () => {
			const scrollDirection = window.scrollY > window.previousScrOllPosition ? "down" : "up";
			console.log(scrollDirection, window.scrollY, window.previousScrOllPosition);

			if (window.scrollY > 50 && !this.scrolled && scrollDirection === "down") {
				this.scrolled = true;
				header.classList.add("scrolled");
			} else if (window.scrollY < 50 && this.scrolled && scrollDirection === "up") {
				this.scrolled = false;
				header.classList.remove("scrolled");
			}

			window.previousScrOllPosition = window.scrollY;
		});

		window.previousScrOllPosition = window.scrollY;
		// trigger scroll event
		window.dispatchEvent(new Event("scroll"));
	}

	closeSubMenu() {
		// on document click check if .js--close-sub-menu class, if it is then do the action
		document.addEventListener("click", (e) => {
			if (e.target.closest(".js--close-sub-menu")) {
				e.preventDefault();
				jQuery('.max-mega-menu').data('maxmegamenu').hideAllPanels();
			}
		});
	}

}
